import { createAsyncThunk } from '@reduxjs/toolkit';
import { MenuCategory } from '../MenuCategory/menuCategorySlice';
import { createApiRequest } from '../../utils/apiUtils';

const getToken = () => localStorage.getItem('accessToken');

export const fetchMenuPreview = createAsyncThunk<MenuCategory[], string>(
  'menuPreview/fetchMenuPreview',
  async (storeId, { rejectWithValue }) => {
    try {
      const response = await createApiRequest<MenuCategory[]>(`/stores/${storeId}/categories`, {
        method: 'GET',
        requiresAuth: true,
      });
      
      if (!response) {
        return rejectWithValue('No data received from server');
      }
      
      return response;
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  }
);
